// extracted by mini-css-extract-plugin
export default {"nameAddressHeader":"Explore_nameAddressHeader__g1gXq","name":"Explore_name__I2gg3","ageAddress":"Explore_ageAddress__RChwU","noMatch":"Explore_noMatch__If1ss"};